import React from "react";
import QueueAnim from 'rc-queue-anim';
import './index.less'
import {Col, Row} from "antd";

export default class DatalinkBanner extends React.Component {

    render() {
        return (
            <div className='Datalink-banner'>
                <QueueAnim
                    key="QueueAnim"
                    type={['bottom', 'top']}
                    delay={200}
                    className='Datalink-banner-content'
                >
                    <h1>更远，更快，更稳</h1>
                </QueueAnim>
            </div>
        )

    }
}
